import React, { useEffect, useState, useContext } from 'react'
import { Container } from 'react-bootstrap'
import { getContent } from '../Network/Content'
import { LanguageContext } from '../Language/LanguageContext'
import Parser from 'html-react-parser';
import { setDocumentTitle } from '../AppTitle'
import { Container as AppContainer, HeaderTitle } from '../Library'

function ViewTerm() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.cookie
    const [content, setContent] = useState("")

    useEffect(()=>{
        setDocumentTitle("Term and Policy")
        getContent(1,
            (data)=>{
                setContent(data.content)
            },
            (error)=>{})
    },[])

    return (
        <Container>
            <AppContainer id="view-term" topbarTitle={lang.term_policy}>
                <HeaderTitle title={lang.term_policy} style={{marginTop: 20}}/>
                <div>
                    {Parser(content)}
                </div>
            </AppContainer>
        </Container>
    )
}

export default ViewTerm
